interface Props {
  page:       number;
  pageSize:   number;
  total:      number;
  totalPages: number;
  onPage:     (p: number) => void;
  onPageSize: (s: number) => void;
}

const PAGE_SIZES = [10, 25, 50];

export default function PaginationBar({ page, pageSize, total, totalPages, onPage, onPageSize }: Props) {
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to   = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 mt-4 font-georgia text-navy">
      <span className="text-teal text-xs whitespace-nowrap">
        {total === 0 ? 'No records' : `${from}–${to} of ${total}`}
      </span>

      <div className="flex items-center gap-1.5 sm:gap-2 ml-auto">
        <select
          className="input-field !w-auto !py-1 !px-1.5 text-xs"
          value={pageSize}
          onChange={(e) => onPageSize(Number(e.target.value))}
          aria-label="Rows per page"
        >
          {PAGE_SIZES.map((s) => <option key={s} value={s}>{s}/pg</option>)}
        </select>

        <button
          onClick={() => onPage(page - 1)}
          disabled={page <= 1}
          aria-label="Previous page"
          className="btn-secondary !px-2 !py-1 text-xs disabled:opacity-40"
        >
          ‹
        </button>
        <span className="text-xs text-teal whitespace-nowrap">
          {page}/{totalPages || 1}
        </span>
        <button
          onClick={() => onPage(page + 1)}
          disabled={page >= totalPages}
          aria-label="Next page"
          className="btn-secondary !px-2 !py-1 text-xs disabled:opacity-40"
        >
          ›
        </button>
      </div>
    </div>
  );
}
